angular.module("mailings_types")

    .controller("MailingTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'modalService','$filter', '$translate', function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, modalService, $filter, $translate) {

        //Comprobamos si tiene permiso escritura


        $scope.allowWrite = true// LoginService.permissionExist("MAILINGS_WRITE");

        $rootScope.title = $filter('translate')('mailings_types.title');

        $scope.mailing_type = {};


        //Gestor de texto 
     

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('mailings_types.title'), url: `mailings_types.list` },
                { title: $filter('translate')('mailings_types.add') },

            ];
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('mailings_types.title'), url: `mailings_types.list` },
                { title: $filter('translate')('mailings_types.edit') },
            ];

            Restangular.one('MailingsTypes', $stateParams.id).get().then(function (result) {

                $scope.mailing_type = result;
            });
        }

        $scope.save = function () {

            if (!angular.isUndefined($scope.mailing_type.id)) {
                $scope.mailing_type.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('mailings_types.add_success'));
                        $state.go("mailings_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('MailingsTypes').post($scope.mailing_type).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('mailings_types.add_success'));
                        $state.go("mailings_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('mailings_types.delete'),
                message: $filter('translate')('mailings_types.delete_message') + " " + $scope.mailing_type.name + "?",
                onAccept: function () {
                    $scope.mailing_type.remove().then(function () {
                        toastr.success($filter('translate')('mailings_types.remove_success'));
                        $state.go("mailings_types.list");
                    });
                }
            });
        };



    }])

    ;

